module.exports = __webpack_public_path__ + "static/media/analysis-macrovector-01 2.015f79e5.png";